/**
 * Liberty step images - language-specific paths for the "How does it work" section.
 * Folder structure: public/images/{LANG_FOLDER}/{filename}
 * Fallback: /images/instruction-imagery-step{N}.png
 */

const LIBERTY_STEP_IMAGES = {
  EN: {
    folder: 'EN',
    steps: [
      'Step 1. Settings menu.PNG',
      'Step 2. Settings with CamAPS Liberty OFF.PNG',
      'Step 3. Training.PNG',
      'Step 4. Confirming not pregnant or under 13.PNG',
      'Step 5. Turning CamAPS Liberty ON.PNG',
      'Step 6. Home screen with Liberty ON.PNG',
    ],
  },
  'EN-CA': {
    folder: 'EN-CAN',
    steps: [
      'Step 1. Settings menu.PNG',
      'Step 2. Settings with CamAPS Liberty OFF.PNG',
      'Step 3. Training.PNG',
      'Step 4. Confirming not pregnant or under 13.PNG',
      'Step 5. Turning CamAPS Liberty ON.PNG',
      'Step 6. Home screen with Liberty ON.PNG',
    ],
  },
  DE: {
    folder: 'DE',
    steps: [
      'Step 1. Settings menu.PNG',
      'Step 2. Settings with CamAPS Liberty OFF.PNG',
      'Step 3. Training.PNG',
      'Step 4 Confirming not pregnant or under 13.PNG',
      'Step 5. Turning CamAPS Liberty ON.PNG',
      'Step 6. Home screen with CamAPS Liberty ON.PNG',
    ],
  },
  FR: {
    folder: 'FR',
    steps: [
      '1. Settings menu.PNG',
      '2. Settings with CamAPS Liberty OFF.PNG',
      '3. Training.PNG',
      '4. Confirming not pregnant or under 13.PNG',
      '5. Turning CamAPS Liberty ON.PNG',
      '6. Home screen with Liberty ON.PNG',
    ],
  },
  'FR-FR': {
    folder: 'FR',
    steps: [
      '1. Settings menu.PNG',
      '2. Settings with CamAPS Liberty OFF.PNG',
      '3. Training.PNG',
      '4. Confirming not pregnant or under 13.PNG',
      '5. Turning CamAPS Liberty ON.PNG',
      '6. Home screen with Liberty ON.PNG',
    ],
  },
  'FR-CA': {
    folder: 'FR-CAN',
    steps: [
      '1. Settings menu.PNG',
      '2. Settings with CamAPS Liberty OFF.PNG',
      '3. Training.PNG',
      '4 Confirming not pregnant or under 13.PNG',
      '5. Turning CamAPS Liberty ON.PNG',
      '6. Home screen with Liberty ON.PNG',
    ],
  },
  NL: {
    folder: 'NL',
    steps: [
      '1. Settings menu.PNG',
      '2. Settings with CamAPS Liberty OFF.PNG',
      '3. Training.PNG',
      '4. Confirming not pregnant or under 13.PNG',
      '5. Turning CamAPS Liberty ON.PNG',
      '6. Home screen with Liberty ON.PNG',
    ],
  },
  IT: {
    folder: 'IT',
    steps: [
      '1. Settings menu.PNG',
      '2. Settings with CamAPS Liberty OFF.PNG',
      '3. Training.PNG',
      '4. Confirming not pregnant or under 13.PNG',
      '5. Turning CamAPS Liberty ON.PNG',
      '6. Home screen with CamAPS Liberty ON.PNG',
    ],
  },
  CZ: {
    folder: 'CZ',
    steps: [
      'Step 1. Settings menu.PNG',
      'Step 2. Settings with CamAPS Liberty OFF.PNG',
      'Step 3. Training.PNG',
      'Step 4. Confirming not pregnant or under 13.PNG',
      'Step 5. Turning CamAPS Liberty ON.PNG',
      'Step 6. Home screen with Liberty ON.PNG',
    ],
  },
  FI: {
    folder: 'FI',
    steps: [
      '1. Settings menu.PNG',
      '2. Settings with CamAPS Liberty OFF.PNG',
      '3. Training.PNG',
      '4. Confirming not pregnant or under 13.PNG',
      '5. Turning CamAPS Liberty ON.PNG',
      '6. Home screen with Liberty ON.PNG',
    ],
  },
  PL: {
    folder: 'PL',
    steps: [
      '1. Settings menu.PNG',
      '2. Settings with CamAPS Liberty OFF.PNG',
      '3. Training.PNG',
      '4. Confirming not pregnant or under 13.PNG',
      '5. Turning CamAPS Liberty ON.PNG',
      '6. Home screen with CamAPS Liberty ON.PNG',
    ],
  },
  SE: {
    folder: 'SE',
    steps: [
      '1. Settings menu.PNG',
      '2. Settings with camAPS Liberty OFF.PNG',
      '3. Training.PNG',
      '4 Confirming not pregnant or under 13.PNG',
      '5. Turning CamAPS Liberty ON.PNG',
      '6. Home screen with Liberty ON.PNG',
    ],
  },
  NO: {
    folder: 'NO',
    steps: [
      '1. Settings menu.PNG',
      '2. Settings with CamAPS Liberty OFF.PNG',
      '3. Traning.PNG',
      '4. Confirming not pregnant or under 13.PNG',
      '5. Turning CamAPS Liberty ON.PNG',
      '6. Home screen with Liberty ON.PNG',
    ],
  },
  DK: {
    folder: 'DK',
    steps: [
      'Step 1. Settings menu.PNG',
      'Step 2. Settings with CamAPS Liberty OFF.PNG',
      'Step 3. Training.PNG',
      'Step 4. Confirming not pregnant or under 13.PNG',
      'Step 5. Turning CamAPS Liberty ON.PNG',
      'Step 6. Home screen with Liberty ON.PNG',
    ],
  },
  ES: {
    folder: 'ES',
    steps: [
      '1. Settings menu.PNG',
      '2. Settings with CamAPS Liberty OFF.PNG',
      '3. Training.PNG',
      '4. Confirming not pregnant or under 13.PNG',
      '5. Turning CamAPS Liberty ON.PNG',
      '6. Home screen with CamAPS Liberty ON.PNG',
    ],
  },
};

export function getLibertyStepImagePath(language, stepNumber) {
  const config = LIBERTY_STEP_IMAGES[language];
  if (config && stepNumber >= 1 && stepNumber <= 6) {
    const filename = config.steps[stepNumber - 1];
    return `/images/${config.folder}/${filename}`;
  }
  return `/images/instruction-imagery-step${stepNumber}.png`;
}
